/** Enumerador com os status da medição.
 * @category Measurements
 */
export enum EMeasurementStatus {
  ANDAMENTO = "andamento",
  AGUARDANDO = "aguardando",
  APROVADA = "aprovada",
  FATURADA = "faturada",
}

/** Enumerador com os status da ordem de faturamento das medições.
 * @category Measurements
 */
export const enum EOrderStatus {
  PROCESSING = "processing",
  IMPORTED = "imported",
  CANCELED = "canceled",
  ERROR = "error",
  DELETED = "deleted",
}
